<template>
  <main-template>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card elevation="2" :loading="loading">
            <v-card-title class="headline primary white--text">
              <v-icon left color="white">mdi-cog</v-icon>
              Configurações da calculadora FUNDEB
              <v-spacer></v-spacer>
              <v-btn text dark @click="$router.push({ name: 'fundeb.calculadora' })">
                <v-icon left>mdi-arrow-left</v-icon>
                Voltar para Calculadora
              </v-btn>
            </v-card-title>

            <v-card-text class="mt-4">
              <v-row align="center">
                <v-col cols="12" md="4">
                  <v-select
                    v-model="selectedAnoId"
                    :items="anos"
                    item-text="descricao"
                    item-value="id"
                    label="Selecione o Ano para Configurar"
                    outlined
                    @change="carregarParametros"
                  ></v-select>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <h3 class="title mb-4 primary--text">Importar configurações de outro ano?</h3>
              <v-row align="center">
                <v-col cols="12" md="4">
                  <v-row v-if="parametros" align="center" no-gutters>
                    <v-col cols="6">
                      <v-select
                        v-model="importAnoId"
                        :items="anosDisponiveisParaImportacao"
                        item-text="descricao"
                        item-value="id"
                        label="Importar de outro ano"
                        outlined
                        class="mr-2"
                      ></v-select>
                    </v-col>
                    <v-col cols="6 mb-6">
                      <v-btn
                        color="info"
                        outlined
                        @click="importarConfiguracoes"
                        :disabled="!importAnoId"
                      >
                        <v-icon left>mdi-content-copy</v-icon>
                        Importar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <div v-if="parametros">
                <h3 class="title mb-4 primary--text">Valores Mínimos e Percentuais</h3>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="parametros.vaaf_min"
                      label="VAAF Mínimo Definido"
                      prefix="R$"
                      type="number"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="parametros.vaat_min"
                      label="VAAT Mínimo Definido"
                      prefix="R$"
                      type="number"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="parametros.p_vaaf"
                      label="% Complementação VAAF"
                      suffix="%"
                      type="number"
                      step="0.01"
                      outlined
                      @input="validaPercentual('p_vaaf')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="parametros.p_vaat"
                      label="% Complementação VAAT"
                      suffix="%"
                      type="number"
                      step="0.01"
                      outlined
                      @input="validaPercentual('p_vaat')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="parametros.p_vaar"
                      label="% Complementação VAAR"
                      suffix="%"
                      type="number"
                      step="0.01"
                      outlined
                      @input="validaPercentual('p_vaar')"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <h3 class="title mt-6 mb-4 primary--text">Fatores de Ponderação</h3>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>Segmento / Modalidade</th>
                      <th width="150">FP VAAF</th>
                      <th width="150">FP VAAT</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(fator, key) in parametros.fatores" :key="key">
                      <td>{{ fator.nome }}</td>
                      <td>
                        <v-text-field
                          v-model="fator.fp_vaaf"
                          dense
                          hide-details
                          type="number"
                          step="0.01"
                        >
                        </v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="fator.fp_vaat"
                          dense
                          hide-details
                          type="number"
                          step="0.01"
                        >
                        </v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>

                <h3 class="title mt-6 mb-4 primary--text">Condicionalidades (Textos)</h3>
                <v-row v-for="(cond, index) in parametros.condicionalidades" :key="index">
                  <v-col cols="12">
                    <v-textarea
                      v-model="parametros.condicionalidades[index]"
                      :label="`Condicionalidade ${index + 1}`"
                      rows="2"
                      outlined
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-col cols="12" class="pt-4">
                  <v-btn color="primary" @click="salvarConfiguracoes" :loading="saving" block large>
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar Configurações
                  </v-btn>
                </v-col>
              </div>
              <v-alert v-else-if="!loading" type="info" class="mt-4">
                Selecione um ano para visualizar ou criar as configurações.
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </main-template>
</template>

<script>
export default {
  name: "FundebConfiguracoes",
  data() {
    return {
      loading: false,
      saving: false,
      selectedAnoId: null,
      importAnoId: null,
      anos: [],
      parametros: null,
      // Estrutura padrão para novos anos (vazia conforme sugerido)
      defaultParams: {
        vaaf_min: 0,
        vaat_min: 0,
        p_vaaf: 0,
        p_vaat: 0,
        p_vaar: 0,
        fatores: {
          creche_integral_publica: {
            nome: "Creche Integral Pública",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          creche_integral_conveniada: {
            nome: "Creche Integral Conveniada",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          creche_parcial_publica: {
            nome: "Creche Parcial Pública",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          creche_parcial_conveniada: {
            nome: "Creche Parcial Conveniada",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          pre_escola_integral_publica: {
            nome: "Pré-Escola Integral Pública",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          pre_escola_integral_conveniada: {
            nome: "Pré-Escola Integral Conveniada",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          pre_escola_parcial_publica: {
            nome: "Pré-Escola Parcial Pública",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          pre_escola_parcial_conveniada: {
            nome: "Pré-Escola Parcial Conveniada",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          ef_anos_iniciais_urbano: {
            nome: "Ens. Fund. Anos Iniciais Urbano",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          ef_anos_iniciais_rural: {
            nome: "Ens. Fund. Anos Iniciais Rural",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          ef_anos_finais_urbano: {
            nome: "Ens. Fund. Anos Finais Urbano",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          ef_anos_finais_rural: {
            nome: "Ens. Fund. Anos Finais Rural",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          ef_integral: {
            nome: "Ensino Fundamental Integral",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          em_urbano: {
            nome: "Ensino Médio Urbano",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          em_rural: {
            nome: "Ensino Médio Rural",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          em_integral: {
            nome: "Ensino Médio Integral",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          educacao_especial_creche: {
            nome: "Educação Especial - Creche",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          educacao_especial_pre_escola: {
            nome: "Educação Especial - Pré-Escola",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          educacao_especial_demais: {
            nome: "Educação Especial - Demais Etapas",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          educacao_indigena_quilombola_creche: {
            nome: "Ed. Indígena/Quilombola - Creche",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          educacao_indigena_quilombola_pre_escola: {
            nome: "Ed. Indígena/Quilombola - Pré-Escola",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          educacao_indigena_quilombola_demais: {
            nome: "Ed. Indígena/Quilombola - Demais",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          eja_processo: {
            nome: "EJA com Avaliação no Processo",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          eja_integrada_profissional: {
            nome: "EJA Integrada à Ed. Profissional",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
          formacao_tecnica_profissional: {
            nome: "Formação Técnica e Profissional",
            fp_vaaf: 0,
            fp_vaat: 0,
          },
        },
        condicionalidades: [
          "<strong>I - Gestão Escolar:</strong> Provimento do cargo de diretor de escola por meio de critérios técnicos de mérito e desempenho",
          "<strong>II - Participação dos Estudantes:</strong> Participação em avaliações e no Saeb",
          "<strong>III - Redução de Desigualdades:</strong> Melhoria dos resultados de aprendizagem",
          "<strong>IV - Regime de Colaboração:</strong> Estabelecimento de acordo de cooperação",
          "<strong>V - Currículo BNCC:</strong> Implementação do currículo alinhado à BNCC",
        ],
      },
    };
  },
  computed: {
    anosDisponiveisParaImportacao() {
      return this.anos.filter((a) => a.id !== this.selectedAnoId);
    },
  },
  async mounted() {
    await this.carregarAnos();
    const user = this.$store.getters["Auth/user"];
    if (user && user.ano) {
      this.selectedAnoId = user.ano.id;
      await this.carregarParametros();
    }
  },
  methods: {
    async carregarAnos() {
      this.loading = true;
      try {
        this.anos = await this.$services.anosService.getAnos();
      } catch (error) {
        this.$toast.danger("Erro ao carregar lista de anos.");
      } finally {
        this.loading = false;
      }
    },
    async carregarParametros() {
      if (!this.selectedAnoId) return;

      this.loading = true;
      try {
        const anoObj = this.anos.find((a) => a.id === this.selectedAnoId);
        const data = await this.$services.fundebService.getParameters(anoObj.descricao);

        if (data && data.ano_id === this.selectedAnoId) {
          this.parametros = data;
        } else {
          // Se não houver parâmetros para o ano, inicia com o default (vazio)
          this.parametros = JSON.parse(JSON.stringify(this.defaultParams));
          this.parametros.ano_id = this.selectedAnoId;
        }
      } catch (error) {
        // console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async importarConfiguracoes() {
      if (!this.importAnoId) return;

      this.loading = true;
      try {
        const anoObj = this.anos.find((a) => a.id === this.importAnoId);
        const data = await this.$services.fundebService.getParameters(anoObj.descricao);

        if (data) {
          // Mantém o ano_id do ano que está sendo configurado
          const currentAnoId = this.selectedAnoId;
          this.parametros = { ...data, id: null, ano_id: currentAnoId };
          this.$toast.success(
            `Configurações importadas de ${anoObj.descricao}. Lembre-se de salvar.`
          );
        } else {
          this.$toast.warning("Não foram encontradas configurações para o ano selecionado.");
        }
      } catch (error) {
        this.$toast.danger("Erro ao importar configurações.");
      } finally {
        this.loading = false;
      }
    },
    async salvarConfiguracoes() {
      this.saving = true;
      try {
        await this.$services.fundebService.updateParameters(this.parametros);
        this.$toast.success("Configurações salvas com sucesso!");
        // Recarrega para garantir que pegamos o ID gerado se for novo
        await this.carregarParametros();
      } catch (error) {
        this.$toast.danger("Erro ao salvar configurações.");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
